import React from 'react';
import cl from 'classnames';

import { IconsEnum } from '../../../../../../../assets/icons/types';

import {
  UpdateProductsSetCacheAction,
  FetchProductsSetsCacheKeys
} from '../../../../../../productsSets/productsSetsTypes';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { useProductSelectButton } from '../../../../../../products/components/buttons/ProductSelectButton/hooks/useProductSelectButton';

import { words } from '../../../../../../../locales/keys';

import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';

import {
  ThreeDStockProductsListLightboxSelectButtonProduct,
  ThreeDStockProductsListLightboxSelectButtonProductsSet
} from './ThreeDStockProductsListLightboxSelectButton.types';

interface ThreeDStockProductsListLightboxSelectButtonProps {
  product: ThreeDStockProductsListLightboxSelectButtonProduct;
  productsSet: ThreeDStockProductsListLightboxSelectButtonProductsSet | null;
  productsSetCacheKeys?: FetchProductsSetsCacheKeys;
  updateProductsSetCache: UpdateProductsSetCacheAction<ThreeDStockProductsListLightboxSelectButtonProductsSet>;
}

function ThreeDStockProductsListLightboxSelectButton({
  product,
  productsSet,
  productsSetCacheKeys,
  updateProductsSetCache
}: ThreeDStockProductsListLightboxSelectButtonProps) {
  const { isSelected, handleToggleSelected } = useProductSelectButton({
    product,
    productsSet,
    updateProductsSetCache,
    productsSetCacheKeys
  });

  return (
    <PureTooltipIconButtonHelper
      className={cl(
        'py-2 font-medium inline-flex space-x-1 items-center rounded-md',
        isSelected
          ? 'pl-2 pr-4 whitespace-nowrap text-sm leading-6 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-100 text-white bg-blue-600 hover:bg-blue-500 shadow-sm hover:shadow-md focus:ring-offset-gray-100 dark:focus:ring-offset-gray-900 focus:ring-offset-2'
          : 'text-gray-800 hover:bg-gray-300 bg-gray-200 px-4 focus:ring-white focus:ring-offset-black'
      )}
      dataGa="product-lightbox-select-button"
      i18nText={isSelected ? words.selected : words.select}
      icon={isSelected ? IconsEnum.CHECK : null}
      iconClassName="h-6 w-6 p-0.5"
      tooltipSingleton
      tooltipI18nText={words.selectToAddToTheProject}
      tooltipPlacement={TooltipPlacement.TOP}
      onClick={handleToggleSelected}
    />
  );
}

export default ThreeDStockProductsListLightboxSelectButton;
